import { AbstractControl, ValidatorFn } from '@angular/forms';

export const nifValidator: ValidatorFn = (control: AbstractControl) => {
  const value = control.value;
  if (!value) return null;

  const match = value.match(/^(\d{8})([A-Z])$/i);
  if (!match) return { invalidNif: true };

  const [, number, letter] = match;
  const letters = 'TRWAGMYFPDXBNJZSQVHLCKE';
  const expected = letters[+number % 23];

  return letter.toUpperCase() === expected ? null : { invalidNif: true };
};
